import { gql } from '__generated__';

export default gql(`
  mutation DuplicateProduct($id: ID!) {
    duplicateProduct(id: $id) {
      id
    }
  }
`);
